import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    // name: 'List',
    // component: Home
    // component: () => import(/* webpackChunkName: "about" */ '../views/List.vue')
    redirect: '/list'
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },

  {
    path: '/list',
    name: 'List',
    component: () => import(/* webpackChunkName: "list" */ '@/views/List.vue')
  },
  {
    path: '/gov/:alias',
    name: 'GovHomePage',
    component: () => import(/* webpackChunkName: "gov" */ '@/views/GovHomePage.vue')
  },
  {
    path: '/news/:type/:id',
    name: 'News',
    component: () => import(/* webpackChunkName: "news" */ '@/views/News.vue')
  },
  {
    path: '*',
    redirect: '/list'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
